import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Carousel.css";

function PrevArrow({ onClick }) {
  return (
    <button className="carousel-arrow carousel-arrow--prev" onClick={onClick} aria-label="Previous slide">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    </button>
  );
}

function NextArrow({ onClick }) {
  return (
    <button className="carousel-arrow carousel-arrow--next" onClick={onClick} aria-label="Next slide">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </button>
  );
}

const slides = [
  {
    image: "s1.jpg",
    subtitle: "India's most trusted battery brand",
    link: "/category/inverter-batteries",
  },
  {
    image: "s2.jpg",
    subtitle: "Uninterrupted power for home & office",
    link: "/category/inverter-batteries",
  },
  {
    image: "s3.jpg",
    subtitle: "Reliable power for every journey",
    link: "/category/automotive-batteries",
  },
  {
    image: "s4.jpg",
    subtitle: "Built to endure the toughest fields",
    link: "/category/tractor-batteries",
  },
  {
    image: "s5.jpg",
    subtitle: "Green energy storage you can count on",
    link: "/category/solar-batteries",
  },
  {
    image: "s6.jpg",
    subtitle: "Lightweight power for longer rides",
    link: "/category/e-rickshaw-batteries",
  },
];

function Carousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
    fade: true,
    pauseOnHover: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    appendDots: (dots) => <ul className="carousel-dots">{dots}</ul>,
    customPaging: () => <button className="carousel-dot" />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="carousel-wrapper">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="carousel-slide">
            <img
              src={slide.image}
              alt={`Slide ${index + 1}`}
              className="carousel-image"
            />
            <div className="carousel-overlay" />
            <div className="carousel-caption">
              <p className="carousel-subtitle">{slide.subtitle}</p>
              <Link to={slide.link} className="carousel-cta">
                Explore Range
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Carousel;
